<!-- bad-buyers.component.html -->
<div class="bad-buyers-container">

  @if (loading) {
    @for (_ of [1, 2]; track _) {
      <div class="placeholder text-center" gdColumns="repeat(1, minmax(0, 1fr))" gdGap="5px"
        fxLayout="column" fxLayoutAlign="center">
        <div fxFlex class="skeleton-loader circle"></div>
        <div fxFlex class="skeleton-loader tiny-line"></div>
        <div fxFlex class="skeleton-loader thin-line"></div>
      </div>
    }
  }

  @if (error) {
    <div class="placeholder text-center">
      <mat-icon class="fa fa-exclamation-triangle"></mat-icon>
      <h4>Something went wrong</h4>
      <span>Unable to load bad buyers. Please try again later.</span>
      <button mat-stroked-button color="warn" (click)="reload.emit()">
        <mat-icon>refresh</mat-icon> Retry
      </button>
    </div>
  }

  @if (!loading && !error && badBuyers.length === 0) {
    <div class="placeholder text-center">
      <mat-icon class="fa fa-users groups-icon"></mat-icon>
      <h4>No bad buyers found</h4>
      <span>All buyers are properly configured.</span>
    </div>
  }

  @if (!loading && !error && badBuyers.length) {
    <mat-table [dataSource]="badBuyers">

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>Buyer Name</mat-header-cell>
        <mat-cell *matCellDef="let buyer">{{ buyer.name }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="account">
        <mat-header-cell *matHeaderCellDef>Account #</mat-header-cell>
        <mat-cell *matCellDef="let buyer">{{ buyer.account }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="reasons">
        <mat-header-cell *matHeaderCellDef>Reason</mat-header-cell>
        <mat-cell *matCellDef="let buyer">
          <div class="reasons-cell">
            <ul class="messages-list">
              @for (msg of (expandedBuyer === buyer.account ? buyer.messages : buyer.messages.slice(0, 1)); track $index) {
                <li>{{ msg }}</li>
              }
            </ul>
            @if (buyer.messages.length > 1) {
              <button mat-button type="button" class="toggle-reasons" (click)="expandedBuyer = expandedBuyer === buyer.account ? null : buyer.account">
                {{ expandedBuyer === buyer.account ? 'Show less' : '+' + (buyer.messages.length - 1) + ' more' }}
                <mat-icon iconPositionEnd>{{ expandedBuyer === buyer.account ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            }
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="actions-cell"></mat-header-cell>
        <mat-cell *matCellDef="let buyer" class="actions-cell">
          <button mat-icon-button [matMenuTriggerFor]="menu" [attr.aria-label]="'Open actions menu for ' + buyer.name">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openGroupsDialog(buyer)">
              <mat-icon>group</mat-icon>
              <span>See all buyer's groups</span>
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
  }

</div>
